if (typeof debounce === "undefined") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      var cartItems = this.closest("cart-items");
      var row = this.closest("tr");
      row.classList.add("removed");
      cartItems.updateQuantity(this.dataset.index, 0);

      // update any of the product cards buttons to reflect the change
      if (row) {
        var productId = row.dataset.productId;
        var addToCartButtons = document.querySelectorAll(
          '.add-to-cart[data-product-id="' + productId + '"]'
        );

        addToCartButtons.forEach((el) => {
          el.classList.remove("added");
          el.querySelector(".card-action__label").innerHTML =
            'Add <svg class="icon-cart" aria-hidden="true" focusable="false" role="presentation"><use href="#icon-plus"></svg>';
        });

        // if the row following this one has a class '.cart-item__upsell-row' then we need to remove that too
        var nextRow = row.nextElementSibling;

        if (nextRow && nextRow.classList.contains("cart-item__upsell-row")) {
          nextRow.remove();
        }
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    var main = document.getElementById("main-cart-items");
    var footer = document.getElementById("main-cart-footer");
    var sections = [
      {
        id: "shipping__promo",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
    ];

    if (main) {
      sections.push({
        id: "main-cart-items",
        section: main.dataset.id,
        selector: ".js-contents",
      });
    }

    if (footer) {
      sections.push({
        id: "main-cart-footer",
        section: footer.dataset.id,
        selector: ".js-contents",
      });
    }

    return sections;
  }

  updateQuantity(line, quantity, name) {
    if (!line) {
      return;
    }

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender()
        .map((section) => section.section)
        .filter((section) => section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter) {
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        }

        if (parsedState.item_count > 0) {
          // if the sidecart is open, update the price there too
          var sideCartBtn = document.querySelector(
            ".side-cart__footer .button strong"
          );

          if (sideCartBtn) {
            sideCartBtn.innerHTML =
              Clinicians.formatPrice(parsedState.total_price) + " NZD";
          }

          // update any prices in the cart items
          var cartItems = document.querySelectorAll(".cart-item");

          cartItems.forEach((cartItem) => {
            var id = cartItem.dataset["itemId"];

            // find the final_line_price for the item in the cart
            parsedState.items.forEach((item) => {
              if (item.id == id) {
                var price = item.final_line_price;

                const cartItemPrice = cartItem.querySelector(
                  ".detail-pricing .product-option"
                );

                if (cartItemPrice) {
                  cartItemPrice.innerHTML = Clinicians.formatPrice(price);
                }
              }
            });
          });
        }

        try {
          this.getSectionsToRender().forEach((section) => {
            const element = document.getElementById(section.id);

            if (!element) {
              console.log("cannot find element with id: ", section.id);
              return;
            }

            const elementToReplace = section.selector
              ? element.querySelector(section.selector)
              : element;

            if (!elementToReplace) {
              console.log(
                "cannot find element with selector: ",
                section.selector
              );
              return;
            }

            if (section.id == "shipping__promo") {
              document
                .querySelector(".shipping-threshold")
                .setAttribute("data-total", parsedState.total_price);
            } else {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });
        } catch (e) {
          console.error(e);
        }

        try {
          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`))
            lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();
        } catch (e) {
          console.error(e);
        }
      })
      .catch((e) => {
        console.error({ e });

        this.disableLoading();
      })
      .finally(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        Clinicians.showSidecart();
        const event = new Event("cart__updated");
        document.body.dispatchEvent(event);
      });
  }

  updateLiveRegions(line, itemCount) {
    try {
      if (this.currentItemCount === itemCount) {
        document
          .getElementById(`Line-item-error-${line}`)
          .querySelector(".cart-item__error-text").innerHTML =
          window.cartStrings.quantityError.replace(
            "[quantity]",
            document.getElementById(`Quantity-${line}`).value
          );
      }

      this.currentItemCount = itemCount;

      if (this.lineItemStatusElement) {
        this.lineItemStatusElement.setAttribute("aria-hidden", true);
      }

      const cartStatus = document.getElementById("cart-live-region-text");
      if (cartStatus) {
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
          cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
      }
    } catch (e) {
      //
    }
  }

  getSectionInnerHTML(html, selector) {
    var content = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);

    if (content) {
      return content.innerHTML;
    }

    return "";
  }

  enableLoading(line) {
    var main = document.getElementById("main-cart-items");

    if (main) {
      main.classList.add("cart__items--disabled");
    }

    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
      (overlay) => overlay.classList.remove("hidden")
    );
    document.activeElement.blur();

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }
  }

  disableLoading() {
    var main = document.getElementById("main-cart-items");

    if (main) {
      main.classList.remove("cart__items--disabled");
    }
  }
}

customElements.define("cart-items", CartItems);

/**
 * Add to cart from the product cards
 */
document.addEventListener("click", (event) => {
  const addToCart = event.target.closest(".add-to-cart");

  if (addToCart) {
    event.preventDefault();

    if (
      addToCart.dataset.disabled ||
      addToCart.classList.contains("disabled")
    ) {
      return;
    }

    var btn = addToCart.closest(".card-action");
    var variantId = addToCart.dataset.variantId;

    if (!variantId) {
      if (btn) {
        variantId = btn.closest("tr").querySelector("input[name=id]").value;
      } else {
        variantId = addToCart
          .closest("tr")
          .querySelector("variant-selects")
          .getVariantSelectedId();
      }
    }
    if (btn) {
      btn.classList.add("card-action--loading");
    } else {
      addToCart.classList.add("add-to-cart--loading");
      addToCart.innerHTML = "<div class='dot-pulse'></div>";
    }

    if (window.dataLayer !== undefined) {
      try {
        let priceItem = addToCart.querySelector(".price-item");

        if (!priceItem) {
          const priceItemCard = addToCart.closest(".card");

          if (priceItemCard) {
            priceItem = priceItemCard.querySelector(".price-item--regular");
          }
        }

        if (priceItem) {
          const price = priceItem.innerText.replace("$", "");

          window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              currency: "NZD",
              value: price,
              items: [
                {
                  item_id: addToCart.dataset.variantId,
                  item_name: addToCart.dataset.title,
                  price: price,
                  quantity: 1,
                },
              ],
            },
          });
        }
      } catch (e) {
        console.error("Error pushing to dataLayer", e);
      }
    }

    fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      body: JSON.stringify({
        quantity: 1,
        id: variantId,
      }),
    })
      .then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else {
          return Promise.reject(response);
        }
      })
      .then(function (data) {
        // if we're on the cart page then we need to reload the page
        if (window.location.href.indexOf("/cart") > -1) {
          window.location.reload();
          return;
        }
        if (btn) {
          btn.classList.remove("card-action--loading");
          btn.setAttribute("data-original", btn.innerHTML);
          btn.querySelector(".card-action__label").innerHTML = "Added";

          setTimeout(() => {
            btn.innerHTML = btn.getAttribute("data-original");
          }, 5000);
        } else {
          addToCart.classList.remove("add-to-cart--loading");
          addToCart.setAttribute("data-original", addToCart.innerHTML);
          addToCart.innerHTML = "Added!";

          setTimeout(() => {
            addToCart.innerHTML = addToCart.getAttribute("data-original");
          }, 7000);
        }

        if (data) {
          var cartCount = document.querySelector(".cart-bubble");

          if (cartCount) {
            cartCount.classList.add("active");
          }

          Clinicians.showSidecart();
        }
      });
    return false;
  }
});

window.Clinicians = window.Clinicians || {};

window.Clinicians.formatPrice = (price) => {
  return "$" + (price / 100).toFixed(2);
};

if (typeof window.Clinicians.showSidecart === "undefined") {
  window.Clinicians.showSidecart = function () {
    // if we're on the shopify cart page then we don't need to do anything
    if (window.location.href.indexOf("/cart") > -1) {
      return;
    }

    // remove the product bar if it's visible
    const productBar = document.querySelector(".product-bar");

    if (productBar) {
      productBar.classList.add("off-screen");

      setTimeout(() => {
        productBar.remove();
      }, 500);
    }

    var cart = document.querySelector(".side-cart");

    var footer = document.querySelector(".side-cart__footer");
    footer.classList.remove("side-cart__footer--visible");

    setTimeout(function () {
      cart.classList.add("in");

      document.body.classList.add("page--locked");

      const inner = document.querySelector(".side-cart__inner");
      inner.classList.add("side-cart__inner--loading");
      inner.innerHTML = '<div class="dot-pulse"></div>';

      fetch("/cart")
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          inner.classList.remove("side-cart__inner--loading");

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          if ((items = doc.querySelector(".main-cart-items-table"))) {
            inner.innerHTML = items.outerHTML;
            inner.classList.remove("side-cart__inner--empty");

            if ((promo = doc.querySelector(".shipping__promo"))) {
              inner.prepend(promo);
            }

            if ((worksWith = doc.querySelector("#works-with"))) {
              inner.appendChild(worksWith);
            }
          } else {
            inner.classList.add("side-cart__inner--empty");
            inner.innerHTML =
              '<p class="cart-empty">Your cart is empty. Why not discover research-backed products that can help you achieve your health goals by taking our quiz</p>';
          }

          var updatedFooter = doc.querySelector(".side-cart__footer");

          if (updatedFooter) {
            footer.innerHTML = updatedFooter.innerHTML;
            footer.classList.add("side-cart__footer--visible");
          }

          const updatedProductBar = doc.querySelector(".product-bar");

          if (updatedProductBar) {
            document.body.appendChild(updatedProductBar);
          }

          var event = new Event("calculate__promo");
          document.body.dispatchEvent(event);

          const subscribeBtns = cart.querySelectorAll(
            ".product-option__checkbox"
          );
          if (subscribeBtns) {
            subscribeBtns.forEach((subscribeBtn) => {
              subscribeBtn.addEventListener("click", (event) => {
                const subscribeOptions =
                  event.target.parentElement.parentElement.querySelector(
                    ".product-option__select-container"
                  );
                subscribeOptions.classList.toggle("hide");
              });
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }, 300);
  };

  window.Clinicians.hideSidecart = function () {
    var cart = document.querySelector(".side-cart");
    cart.classList.remove("in");

    setTimeout(function () {
      document.body.classList.remove("page--locked");
    }, 500);
  };

  const overlay = document.querySelector(".page-overlay");

  if (overlay) {
    overlay.addEventListener("click", () => {
      var cart = document.querySelector(".side-cart");

      if (cart.classList.contains("in")) {
        Clinicians.hideSidecart();
      }
    });
  }
}

document
  .querySelector(".header__icon--cart")
  .addEventListener("click", function (e) {
    e.preventDefault();

    if (window.location.href.indexOf("/cart") > -1) {
      window.location.reload();
      return false;
    }

    Clinicians.showSidecart();

    return false;
  });

/**
 * Show Subscribe options when Subscribed input is checked
 *
 * For Cart page
 */
const subscribeButtons = document.querySelectorAll(".product-option__checkbox");

if (subscribeButtons) {
  subscribeButtons.forEach((el) => {
    el.addEventListener("click", (event) => {
      const subscribeOptions =
        event.target.parentElement.parentElement.querySelector(
          ".product-option__select-container"
        );
      subscribeOptions.classList.toggle("hide");
    });
  });
}

document.querySelectorAll(".side-cart__close-btn").forEach(function (el) {
  el.addEventListener("click", function (e) {
    e.preventDefault();

    Clinicians.hideSidecart();

    return false;
  });
});

document.addEventListener("keydown", function (e) {
  if (e.keyCode === 27) {
    Clinicians.hideSidecart();
  }
});

const productBar = document.querySelector(".product-bar");

if (productBar) {
  const triggerAdd = document.querySelector(".product-form__submit");

  document.addEventListener(
    "scroll",
    throttle(() => {
      let triggerY = window.innerHeight;

      if (triggerAdd) {
        triggerY = triggerAdd.offsetTop;
      }

      if (window.scrollY > triggerY) {
        productBar.classList.remove("off-screen");
      } else {
        productBar.classList.add("off-screen");
      }
    }, 100)
  );
}
